const toList = (tasks) => {
  if (Array.isArray(tasks)) return tasks;
  return tasks ? Object.values(tasks) : [];
};

// Поиск задач по имени во всех списках: сначала активные, затем выполненные.
// groups — списки с совпадениями в порядке projects, tasks — совпадения по _id списка.
export function searchTasks(
  projects,
  tasksByProject,
  completedByProject,
  text
) {
  const groups = [];
  const tasks = {};
  const query = (text || "").toLowerCase();

  if (!query) return { groups, tasks };

  const matches = (task) =>
    !!task &&
    typeof task.name == "string" &&
    task.name.toLowerCase().includes(query);

  (projects || []).forEach((project) => {
    if (!project || !project._id) return;

    const found = toList(tasksByProject && tasksByProject[project._id])
      .filter(matches)
      .concat(
        toList(completedByProject && completedByProject[project._id]).filter(
          matches
        )
      );

    if (found.length) {
      groups.push({ project: project.name, _id: project._id });
      tasks[project._id] = found;
    }
  });

  return { groups, tasks };
}

// Сколько совпадений рендерить за раз: каждая задача — тяжёлый компонент,
// тысяча совпадений на короткий запрос вешала страницу
export const SEARCH_PAGE_SIZE = 50;

// Первые `limit` совпадений с сохранением порядка списков.
// Списки без попавших в лимит задач не показываются.
export function limitSearchResults(groups, tasks, limit) {
  const visibleGroups = [];
  const visibleTasks = {};
  let total = 0;
  let shown = 0;

  (groups || []).forEach((group) => {
    const list = (tasks && tasks[group._id]) || [];
    total += list.length;

    const room = Math.max(0, limit - shown);
    if (!room || !list.length) return;

    visibleTasks[group._id] = list.slice(0, room);
    shown += visibleTasks[group._id].length;
    visibleGroups.push(group);
  });

  return { groups: visibleGroups, tasks: visibleTasks, total, shown };
}
